<!-- ModalPdfsDiseno.vue — Documentos de una preaprobación, con visor incrustado -->
<!-- El PDF se abre aquí mismo (mismo patrón que Proyectos en el modal de pedidos), -->
<!-- para no mandar al usuario a una pestaña por cada archivo. -->
<template>
  <div class="modal fade" id="modalPdfsDiseno" tabindex="-1" ref="el">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content divisan-modal border-0">
        <div class="modal-header border-0 pb-2">
          <div>
            <span class="badge-cotizacion">{{ diseno?.cotizacion }}</span>
            <h5 class="header-titulo mt-1">
              Documentos ({{ diseno?.pdfs?.length || 0 }})
            </h5>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body pt-2">
          <div v-if="!pdfs.length" class="vacio-container">
            <i class="bi bi-file-earmark-pdf"></i>
            <p class="mt-2 mb-0">Sin documentos adjuntos</p>
          </div>

          <div v-for="pdf in pdfs" :key="pdf.id" class="proyecto-card">
            <div class="proyecto-header">
              <div class="proyecto-meta">
                <i class="bi bi-file-earmark-pdf-fill me-2 text-danger"></i>
                <span class="proyecto-nombre">{{ pdf.nombre_original }}</span>
                <span :class="badgePdf(pdf.estatus)">{{ labelPdf(pdf.estatus) }}</span>
              </div>

              <button
                class="btn-toggle-preview"
                :title="pdf._preview ? 'Ocultar preview' : 'Ver PDF'"
                @click="pdf._preview = !pdf._preview"
              >
                <i class="bi" :class="pdf._preview ? 'bi-eye-slash' : 'bi-eye'"></i>
                {{ pdf._preview ? "Ocultar" : "Ver" }}
              </button>
            </div>

            <div v-if="pdf._preview" class="preview-container">
              <embed :src="pdf.archivo" type="application/pdf" class="pdf-embed" />
            </div>

            <div v-if="pdf.comentario_rechazo" class="comentario">
              <i class="bi bi-chat-left-quote-fill me-2"></i>
              <span>{{ pdf.comentario_rechazo }}</span>
            </div>
          </div>
        </div>

        <div class="modal-footer border-0 pt-0">
          <button class="btn btn-cerrar" data-bs-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { Modal } from "bootstrap";

const el = ref(null);
let modalInstance = null;

const diseno = ref(null);
// Copia local con la bandera de preview; el objeto de la tabla no se toca.
const pdfs = ref([]);

onMounted(() => {
  modalInstance = new Modal(el.value);
});

function abrir(registro) {
  diseno.value = registro;
  pdfs.value = (registro?.pdfs || []).map((p) => ({ ...p, _preview: false }));
  modalInstance.show();
}
defineExpose({ abrir });

const PDF = {
  PENDIENTE: { label: "Pendiente", clase: "pdf-pendiente" },
  APROBADO: { label: "Aprobado", clase: "pdf-aprobado" },
  RECHAZADO: { label: "Rechazado", clase: "pdf-rechazado" },
};
const labelPdf = (v) => PDF[v]?.label || v;
const badgePdf = (v) => `badge-pill ${PDF[v]?.clase || ""}`;
</script>

<style scoped>
.divisan-modal {
  background-color: var(--d-cream);
  border: 2px solid var(--d-brown);
  border-radius: 20px;
}
@media (max-width: 1000px) {
  .divisan-modal {
    margin-top: 4rem;
  }
}
.modal-header {
  padding: 1.1rem 1.4rem 0.8rem;
  border-bottom: 1px solid var(--d-border) !important;
}
.badge-cotizacion {
  background: var(--d-green-dark);
  color: var(--d-cream);
  font-family: var(--d-font-mono);
  font-size: 0.74rem;
  font-weight: 700;
  border-radius: 4px;
  padding: 1px 7px;
}
.header-titulo {
  font-size: 1.05rem;
  font-weight: 800;
  color: var(--d-brown);
  margin: 0;
}
.modal-body {
  padding: 1rem 1.4rem;
}

.vacio-container {
  text-align: center;
  padding: 34px 10px;
  color: var(--d-brown);
  opacity: 0.45;
}
.vacio-container i {
  font-size: 2rem;
}

/* ── Tarjeta de documento (patrón de Proyectos) ─────────── */
.proyecto-card {
  background: white;
  border: 1px solid rgba(96, 108, 56, 0.25);
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 8px;
}
.proyecto-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}
.proyecto-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex-wrap: wrap;
}
.proyecto-nombre {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--d-brown);
  word-break: break-all;
}
.btn-toggle-preview {
  background: none;
  border: 1px solid var(--d-green);
  border-radius: 6px;
  padding: 3px 10px;
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--d-green);
  cursor: pointer;
  white-space: nowrap;
  transition: 0.15s;
}
.btn-toggle-preview:hover {
  background: var(--d-green);
  color: var(--d-cream);
}

.preview-container {
  margin-top: 10px;
}
.pdf-embed {
  width: 100%;
  height: 520px;
  border: 1px solid rgba(64, 34, 8, 0.15);
  border-radius: 8px;
}

.badge-pill {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  border-radius: 20px;
  padding: 1px 9px;
  white-space: nowrap;
}
.pdf-pendiente {
  background: rgba(64, 34, 8, 0.1);
  color: #6d4c41;
}
.pdf-aprobado {
  background: #e8f5e9;
  color: #1b5e20;
}
.pdf-rechazado {
  background: #fdeaea;
  color: #c62828;
}

.comentario {
  display: flex;
  align-items: flex-start;
  margin-top: 8px;
  padding: 7px 10px;
  background: rgba(198, 40, 40, 0.07);
  border-left: 3px solid #c62828;
  border-radius: 0 7px 7px 0;
  font-size: 0.8rem;
  color: #b02020;
}

.modal-footer {
  border-top: 1px solid var(--d-border) !important;
  padding: 0.8rem 1.4rem;
}
.btn-cerrar {
  background: none;
  border: 1px solid var(--d-green);
  color: var(--d-green);
  font-weight: 700;
  border-radius: 8px;
  font-size: 0.85rem;
}
.btn-cerrar:hover {
  background: var(--d-green);
  color: var(--d-cream);
}
</style>
